import React from 'react';
import { Header } from './components/Header';
import { Advertorial } from './components/Advertorial';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen bg-gray-100" data-id="element-0">
      <Header data-id="element-1" />
      <Advertorial data-id="element-2" />
      <Footer data-id="element-3" />
    </div>;
}